import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import ErrorLabel from "../error_label";
import $ from "jquery";
import {
  actionEmpStatus,
  resetEmpStatus,
  actionEmployeeAdd,
  resetEmployeeAdd,
  actionChangeStatus,
  //   actionZoneList,
  //   resetZoneList,
} from "./../../routes/app/auth/list/store/index";
import {
  actionZoneList,
  resetZoneListResponse,
} from "../../routes/app/public/store";
import toast from "react-hot-toast";
import {
  TOAST_DURATION,
  TOAST_POSITION,
  TOAST_SUCCESS_COLOR,
} from "../../common/app_constant";

const EmployeeAddEdit = (props) => {
  const [zoneDropdown, setZoneDropdown] = useState([]);
  const [loading, setLoading] = useState(false)
  const [status, setStatus] = useState(props?.employeeData?.status === 'ON-HOLD')
  const dispatch = useDispatch();
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    control,
    setValue
  } = useForm();

  const { EmpStatus, EmployeeAdd, EmployeeChangeStatus } = useSelector((state) => ({
    ...state.listStore,
  }));

  const { zoneList } = useSelector((state) => ({
    ...state.publicStore,
  }));


  const initialRender = () => {
    if (props.show === true) {
      $("#root").addClass("modal-open");
      $("#root").append('<div class="modal-backdrop fade show"></div>');
      dispatch(actionZoneList());
    } else {
      $("#root").removeClass("modal-open");
      $(".modal-backdrop").remove();
      reset();
    }
  };
  useEffect(initialRender, [props.show]);

  function formatStatus(status) {
    console.log("stattt", status)
    if (status) {
      return status
        .toLowerCase()
        .split("_")
        .map((word, index) =>
          index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word
        )
        .join("-");
    }
    return null
  }
  useEffect(() => {
    if (props.employeeData) {
      console.log(props?.employeeData?.status)
      Object.keys(props.employeeData).forEach((key) => setValue(key, props.employeeData[key]))
    }
    setValue('status', props?.employeeData?.status)
    setValue('city_id', props?.employeeData?.userCity?.id)
  }, [props.employeeData]);


  useEffect(() => {
    if (EmpStatus) {
      dispatch(resetEmpStatus());
      $("#add_edit_employee").prop("disabled", false);
      if (EmpStatus.status) {
        setLoading(false)
        toast.success(EmpStatus.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
        props.handleClose();
      } else {
        setLoading(false)
        toast.error(EmpStatus?.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {},
        });
      }
    }
  }, [EmpStatus]);


  useEffect(() => {
    if (EmployeeChangeStatus) {
      dispatch(resetEmpStatus());
      $("#approve-button").prop("disabled", false);
      if (EmployeeChangeStatus.status) {
        setLoading(false)
        toast.success(EmployeeChangeStatus.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
        props.handleClose();
      } else {
        setLoading(false)
        toast.error(EmpStatus?.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {},
        });
      }
    }
  }, [EmployeeChangeStatus]);

  useEffect(() => {
    if (EmployeeAdd) {
      dispatch(resetEmployeeAdd());
      $("#add_edit_employee").prop("disabled", false);
      if (EmployeeAdd.status === true) {
        setLoading(false)
        toast.success(EmployeeAdd.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
        props.handleClose();
      } else {
        setLoading(false)
        toast.error(EmployeeAdd?.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {},
        });
      }
    }
  }, [EmployeeAdd]);

  useEffect(() => {
    if (zoneList) {
      dispatch(resetZoneListResponse());
      if (zoneList.status) {
        setZoneDropdown(zoneList.data);
      }
    }
  }, [zoneList]);

  const generateCityList = () => {
    var menu = [];
    if (zoneDropdown && zoneDropdown.length) {
      zoneDropdown.map((item, index) => {
        menu.push(
          <option value={item.id} key={index}>
            {item.name}
          </option>
        );
      });
    }
    return menu;
  };

  const onSubmit = (data, event) => {

    console.log('data', data)
    event.preventDefault(); // Prevent default form submission

    const updatedData = { ...data }
    // delete updatedData.email
    delete updatedData.mobile
    console.log("dsfdsfdsa")

    //approved employee
    if (props?.employeeData?.status === 'ON-HOLD') {
      const actionType = event.nativeEvent.submitter.value;
      updatedData.id = props.employeeData.id;
      if (actionType === "approve") {
        $("#approve-button-loader").removeClass("hidden");
        $("#approve-button").prop("disabled", true);
        setLoading(true);
        dispatch(actionChangeStatus({ id: props.employeeData.id, email: props.employeeData.email, status: "ACTIVE" }));
      } else if (actionType === "reject") {
        $("#reject-button-loader").removeClass("hidden");
        $("#reject-button").prop("disabled", true);
        setLoading(true);
        dispatch(actionChangeStatus({ id: props.employeeData.id, email: props.employeeData.email, status: "INACTIVE" }));
      }
    } else if (props.employeeData) {
      updatedData.id = props.employeeData.id;
      $("#add-edit-employee-loader").removeClass("hidden");
      $("#add_edit_employee").prop("disabled", true);
      dispatch(actionEmpStatus({ id: props.employeeData.id, ...updatedData }));
      setLoading(true)
    } else {
      $("#add-edit-employee-loader").removeClass("hidden");
      $("#add_edit_employee").prop("disabled", true);
      dispatch(actionEmployeeAdd(data));
      setLoading(true)
    }
  };
  return (
    <>
      <div
        class="modal fade show"
        id="employee"
        tabindex="-1"
        aria-labelledby="employeeAddEdit"
        aria-hidden="true"
        style={{ display: `${props.show === true ? "block" : "none"}` }}
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="employeeAddEdit">
                Employee {props.employeeData ? "Edit" : "Add"}
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  props.handleClose();
                }}
              ></button>
            </div>
            <div class="modal-body">
              <div className="row">
                <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                  <form
                    noValidate
                    autoComplete="Off"
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <div className="form-body">
                      <div className="row mb-3">
                        {props.employeeData && (
                          <div className="col-12 col-md-6 mb-2">
                            <div className="form-group">
                              <label className="label-control">ID</label>
                              <input
                                className="form-control"
                                id="id"
                                name="id"
                                readOnly
                                {...register("id")}
                              />
                            </div>
                          </div>
                        )}
                        <div className="col-12 col-md-6 mb-2">
                          <div className="form-group">
                            <label className="label-control">Full Name</label>
                            <input
                              type="text"
                              readOnly={props?.employeeData?.status === 'ON-HOLD'}
                              className="form-control"
                              id="full_name"
                              name="full_name"
                              {...register("full_name")}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 mb-2">
                          <div className="form-group">
                            <label className="label-control">
                              Mobile No&nbsp;<span className="danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="number"
                              id="mobile"
                              readOnly={props?.employeeData ? true : false}
                              onInput={(e) => {
                                if (e.target.value.length > 10) {
                                  e.target.value = e.target.value.slice(0, 10);
                                }
                              }}
                              name="mobile"
                              {...register('mobile')}
                            />
                            {errors.mobile && (
                              <ErrorLabel message={errors.mobile?.message} />
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 mb-2">
                          <div className="form-group">
                            <label className="label-control">
                              Email&nbsp;<span className="danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="email"
                              id="email"
                              name="email"
                              // readOnly={props?.employeeData ? true : false}
                              {...register('email')}
                            />
                            {errors.email && (
                              <ErrorLabel message={errors.email?.message} />
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 mb-2">
                          <div className="form-group">
                            <label className="label-control">
                              City&nbsp;
                              <span className="danger">*</span>
                            </label>
                            <select
                              className="form-control"
                              id="city_id"
                              name="city_id"
                              disabled={props?.employeeData?.status === 'ON-HOLD'}
                              placeholder="Select..."
                              {...register("city_id", {
                                required: "This is required.",
                              })}
                            >
                              <option value="">City</option>
                              {generateCityList()}
                            </select>
                            {errors.city_id && (
                              <ErrorLabel message={errors.city_id?.message} />
                            )}
                          </div>
                        </div>

                        {props?.employeeData?.status !== 'ON-HOLD' &&
                          <div className="col-12 col-md-6 mb-2">
                            <div className="form-group">
                              <label className="label-control">
                                Status&nbsp;
                                <span className="danger">*</span>
                              </label>
                              <select
                                className="form-control"
                                id="status"
                                disabled={props?.employeeData?.status === 'ON-HOLD'}
                                defaultValue="active"
                                name="status"
                                placeholder="Select.."
                                {...register("status", {
                                  required: "This is required.",
                                })}
                              >
                                <option value="ACTIVE">Active</option>
                                <option value="INACTIVE">Inactive</option>
                              </select>
                              {errors.status && (
                                <ErrorLabel message={errors.status?.message} />
                              )}
                            </div>
                          </div>
                        }
                      </div>

                    </div>
                    {props?.employeeData?.status !== 'ON-HOLD' ?
                      <div className="form-actions border-0 float-none mt-1">
                        {
                          loading ?
                            <button
                              id="add_edit_employee"
                              className="btn btn-primary shadow round text-uppercase me-2"
                              type="submit"
                            >
                              <div className="d-flex align-items-center">
                                Submit
                                <span
                                  id="add-edit-employee-loader"
                                  className="spinner-border spinner-border-sm ml-half hidden"
                                ></span>
                              </div>
                            </button>
                            :
                            <button
                              id="add_edit_employee"
                              className="btn btn-primary shadow round text-uppercase me-2"
                              type="submit"
                            >
                              <div className="d-flex align-items-center">
                                Submit
                              </div>
                            </button>
                        }
                        <button
                          className="btn btn-outline-secondary mr-1 shadow round text-uppercase"
                          onClick={(event) => {
                            props.handleClose();
                            event.preventDefault();
                          }}
                        >
                          {" "}
                          Cancel
                        </button>
                      </div>
                      :

                      <div className="form-actions border-0 float-none mt-1">
                        {
                          loading ? (
                            <button
                              id="approve-button"
                              className="btn btn-primary shadow round text-uppercase me-2"
                              type="submit"
                              name="action"
                              value="approve"
                              disabled
                            >
                              <div className="d-flex align-items-center">
                                Submit
                                <span
                                  id="approve-button-loader"
                                  className="spinner-border spinner-border-sm ml-half"
                                ></span>
                              </div>
                            </button>
                          ) : (
                            <button
                              id="approve-button"
                              className="btn btn-success shadow round text-uppercase me-2"
                              type="submit"
                              name="action"
                              value="approve"
                            >
                              <div className="d-flex align-items-center">
                                Approve
                              </div>
                            </button>
                          )
                        }

                        {
                          loading ? (
                            <button
                              id="reject-button"
                              className="btn btn-danger shadow round text-uppercase"
                              type="submit"
                              name="action"
                              value="reject"
                              disabled
                            >
                              <div className="d-flex align-items-center">
                                Reject
                                <span
                                  id="reject-button-loader"
                                  className="spinner-border spinner-border-sm ml-half"
                                ></span>
                              </div>
                            </button>
                          ) : (
                            <button
                              id="reject-button"
                              className="btn btn-danger shadow round text-uppercase"
                              type="submit"
                              name="action"
                              value="reject"
                            >
                              Reject
                            </button>
                          )
                        }
                      </div>
                    }
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default EmployeeAddEdit;
